import http from '@/communication/AuthConnection'

export default async ({ commit }, payload) => {
  const result = await http.post(`/v1/result/set-default-distributor`, payload)
  return result
  // if (data.success) {
  //   return true
  // } else {
  //   return Promise.reject(Error('Não conseguimos escolher essa empresa'))
  // }
}



// WEBPACK FOOTER //
// ./src/brain/result/set-default-distributor/index.js